export async function loginApi() {
  let response = await fetch(process.env.REACT_APP_API_ROOT + "auth/facebook", {
    method: "POST"
  });

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function logoutApi() {
  await fetch(process.env.REACT_APP_API_ROOT + "auth", { method: "DELETE" });
}
